module.exports = __webpack_public_path__ + "img/root11.4aed6159.png";